import React from "react";
import HeadingSection from "../components/about/HeadingSection";
import AboutSection from "../components/about/AboutSection";
import CompanyFooter from "../components/about/CompanyFooter";

export default function About() {
  return (
    <section>
      <div className="w-full bg-gray-50 min-h-screen">
      <main className="px-20 py-20 mx-auto w-full max-w-[1151px] max-md:px-10 max-sm:px-5 max-sm:py-10">
        <HeadingSection />
        <AboutSection />
        <CompanyFooter />
      </main>
      </div>
    </section>
  );
}
